import {useCallback} from 'react';

import {useCommonDataHook} from 'src/hooks/use-common-data-hook';
import {createNewGroup} from 'src/openapi/admin/apis/AccountGroupApi';
import {useAppDispatch} from 'src/store/hooks';

import type {AccountGroupFullInfo} from 'src/openapi/admin/models/AccountGroupFullInfo';

type Props = {
    accountId: number,
};

export const useCreateGroup = ({accountId}: Props) => {
    const apiDispatch = useAppDispatch();

    const getDispatchAction = useCallback(() => {
        const payload: {success: true, error: false, data: AccountGroupFullInfo} = {
            success: true,
            error: false,
            data: {
                accountId,
                name: '',
                ownerId: 0,
                groupOnlyCollaboration: false,
                overridePrivacyPermission: false,
                accountPrivacyEnabled: false,
                groupPrivacyEnabled: false,
                userPrivacyEnabled: false,
                enableMyGroupPrivacy: false,
            },
        };
        return Promise.resolve({type: '', payload});
    }, [accountId]);

    const saveDispatchAction = useCallback((accountGroupFullInfo: AccountGroupFullInfo) => apiDispatch(createNewGroup({
        accountGroupFullInfo,
    })), [apiDispatch]);

    return useCommonDataHook({
        getDispatchAction,
        saveDispatchAction,
        initValue: {
            accountId: 0,
            name: '',
            ownerId: 0,
            groupOnlyCollaboration: false,
            overridePrivacyPermission: false,
            accountPrivacyEnabled: false,
            groupPrivacyEnabled: false,
            userPrivacyEnabled: false,
            enableMyGroupPrivacy: false,
        },
    });
};
